import { useState, useEffect, startTransition } from 'react';

const TWO_DAYS_MS = 2 * 24 * 60 * 60 * 1000;

const useDisableAfterBuffer = (startTime?: string | number | Date, bufferMs: number = 15 * 60 * 1000): boolean => {
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (!startTime) {
      setDisabled(false);
      return;
    }

    const startMs = new Date(startTime).getTime();
    if (isNaN(startMs)) {
      setDisabled(false);
      return;
    }

    const disableAt = startMs + bufferMs;
    const now = Date.now();
    const delay = disableAt - now;

    if (delay <= 0) {
      setDisabled(true);
      return;
    }

    if (delay > TWO_DAYS_MS) {
      setDisabled(false);
      return;
    }

    const id = window.setTimeout(() => setDisabled(true), delay);
    return () => window.clearTimeout(id);
  }, [startTime, bufferMs]);

  return disabled;
};

export default useDisableAfterBuffer;
